import {
  styled,
  Icon,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
  TooltipPortal,
  StitchesCSS,
} from '@moleculeone/ui';

import { conditionGroupsMeta } from './conditionGroupsMeta';
import { GroupCondition } from './GroupCondition';

const ReagentIconContainer = styled('div', {
  position: 'relative',
  display: 'flex',
  fontSize: '$4',
});

const ReagentIcon = styled(Icon, {
  display: 'inline-block',
  transition: 'transform .25s cubic-bezier(0.16, 1, 0.3, 1), opacity .25s',
});

const StyledReagentTag = styled('button', {
  background: 'none',
  border: 'none',
  outline: 'none',
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '$2',
  padding: '$2 $4 $2 $3',
  borderRadius: '$medium',
  fontSize: '$2',
  fontWeight: 400,
  cursor: 'pointer',
});

const TextContainer = styled('span', {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  variants: {
    fullWidth: {
      true: {
        maxWidth: '100%',
      },
      false: {
        maxWidth: '4rem',
      },
    },
  },
});

type ReagentTagProps = React.ComponentPropsWithoutRef<'div'> & {
  color?: any;
  condition: string;
  text: string;
  smiles?: string;
  css?: StitchesCSS;
  fullWidth?: boolean;
};

export function ReagentTag(props: ReagentTagProps) {
  const { text, condition, smiles, fullWidth = false, ...restProps } = props;

  const conditionMeta = conditionGroupsMeta[condition];

  return (
    <TooltipProvider disableHoverableContent={true}>
      <Tooltip>
        <TooltipTrigger asChild>
          <StyledReagentTag>
            <ReagentIconContainer>
              <ReagentIcon
                icon={conditionMeta?.icon}
                css={{ color: `$${conditionMeta?.color}10` }}
              />
            </ReagentIconContainer>
            <TextContainer fullWidth={fullWidth}>{text}</TextContainer>
          </StyledReagentTag>
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent css={{ width: 'auto', maxWidth: 'none' }}>
            <GroupCondition
              name={condition}
              value={{
                full_name: text,
                smiles,
              }}
            />
          </TooltipContent>
        </TooltipPortal>
      </Tooltip>
    </TooltipProvider>
  );
}
